const LOGO_FRAME_CLASS = "flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full shadow-sm";

function OzonLogo() {
  return (
    <svg viewBox="0 0 485 106" className="w-7" aria-hidden="true">
      <path fill="currentColor" d="M56.49 80.75c12.54-1.59 22.67-11.72 24.27-24.27a28.2 28.2 0 0 0-31.61-31.61C36.6 26.47 26.47 36.6 24.88 49.14a28.2 28.2 0 0 0 31.61 31.61zM58.2.27a53 53 0 0 1 47.16 47.16c3.31 33.4-24.53 61.24-57.94 57.93A53 53 0 0 1 .27 58.2C-3.04 24.8 24.8-3.04 58.2.27zm75.5 2.09h77.31c2.94 0 4.6 3.36 2.83 5.7l-53.49 70.57h41.91c7.64 0 13.65 6.95 12.07 14.87-1.16 5.81-6.61 9.77-12.53 9.77h-83.96c-2.91 0-4.56-3.33-2.81-5.64L168.56 27h-34.4c-5.92 0-11.37-3.97-12.53-9.77-1.59-7.92 4.43-14.87 12.07-14.87zm335.51.28c7.98-1.68 15 4.36 15 12.04v85.03c0 2.97-3.43 4.62-5.75 2.78l-66.69-52.91v41.39c0 7.68-7.02 13.72-15 12.04-5.72-1.2-9.64-6.53-9.64-12.37V5.91c0-2.97 3.43-4.62 5.75-2.78l66.7 52.91V15.01c0-5.84 3.93-11.16 9.64-12.37zM295.56 0c40.83 0 73.93 23.64 73.93 52.8s-33.1 52.8-73.93 52.8-73.93-23.64-73.93-52.8S254.73 0 295.56 0zm0 24.64c-28.21 0-49.29 14.87-49.29 28.16s21.08 28.16 49.29 28.16 49.29-14.86 49.29-28.16-21.08-28.16-49.29-28.16z" />
    </svg>
  );
}

function WildberriesLogo() {
  return (
    <svg viewBox="0 0 500 75.1" className="w-7" aria-hidden="true">
      <path fill="currentColor" d="M210.8 22.1c-5.7 0-10.8 1.7-15.1 4.5V.5h-12.1v48.1c0 14.6 12.2 26.4 27.1 26.4S238 63.3 238 48.5s-12-26.4-27.2-26.4zm-62.6.8c-13.4 1.3-24.4 12.6-24.4 26.1 0 14.2 12.5 26.2 27.1 26.2S178 63.3 178 49c0-6.1-2.2-11.6-5.9-16L145.4.6h-15.6l18.4 22.3zM54.9 52 43.8 24h-8.5l-11 28-11.1-28H0l19.4 49.4h8.5L39.6 44l11.7 29.4h8.5L79.1 24H66L54.9 52zm215.9-29.8c-15.1 0-27.3 11.4-27.3 25.9 0 14.4 10.7 27.1 26.6 27.1 9.5 0 17.2-4.5 22.7-12.1l-9.4-7.5c-2.7 4.8-8 7.6-13.2 7.6-6.8 0-13.5-4.7-14-11.6h39.5V48c-.1-15.2-10.4-25.8-24.9-25.8zm154 0c-15.1 0-27.2 11.4-27.2 26.5 0 14.2 10.7 26.4 26.5 26.4 9.5 0 17.2-4.5 22.7-12.1l-8.3-6.9c-2.9 4.4-8.2 7-14.6 7-6.3 0-13.2-4.7-13.7-11.6h39.3v-4.1c0-14.6-10.2-25.2-24.7-25.2zM467 38.4c0-3.1 4.3-5.5 9.9-5.5s11.8 2.7 15.8 7.1l7.3-8.7c-7-6-14-9.1-22.8-9.1-11 0-22.3 4.9-22.3 16.2 0 13.9 12.3 14.9 22.3 15.7 5.6.4 10.6.8 10.6 4.4 0 3.9-5.7 5.7-10.6 5.7-6.4 0-12.5-2.9-16.6-7.8l-7.8 8.1c6.2 7.4 15.2 10.6 24 10.6 11 0 23.1-5.1 23.1-16.8.1-13.2-12.3-14.5-21.8-15.4-6.2-.7-11.1-1.2-11.1-4.5zm-153.1-3.2V24h-12.1v49.3h12.1V52.4c1.6-11.6 11.1-16.3 22.1-16.3V24h-1.2c-9.3 0-16.1 3.3-20.9 11.2zm38.3 0V24h-12.1v49.3h12.1V52.4c1.6-13.1 13.2-16.3 22.1-16.3V24H373c-9.2 0-16 3.2-20.8 11.2zm-246.6 38.1h12.1V.6h-12.1v72.7zm45.3-10c-8.3 0-15.1-6.5-15.1-14.6s6.7-14.7 15-14.7c8.2 0 15.2 6.5 15.2 14.7s-6.7 14.6-15.1 14.6zm59.9 0c-8.2 0-15.1-6.4-15.1-14.7S202.2 34 210.8 34 226 40.5 226 48.6s-6.9 14.7-15.2 14.7zm-126.1 10h12.1V24H84.7v49.3zm294.7 0h12.1V24h-12.1v49.3zM90.6 0c-4.9 0-9 4-9 9 0 5.1 4.3 8.6 9 8.6 5.2 0 9.2-4.3 9.2-8.8 0-4.6-4.2-8.8-9.2-8.8zm294.8 0c-4.9 0-9.1 4-9.1 9s4 8.6 9.3 8.6 8.9-3.5 8.9-8.4c0-4.9-4.1-9.2-9.1-9.2zm26.2 41.7c2-4.9 6.3-7.7 12.6-7.7s10.2 3 11.8 7.7h-24.4zm-154.1 0c2-4.9 6.3-7.7 12.5-7.7 6.3 0 10.4 3 12 7.7h-24.5z" />
    </svg>
  );
}

function YandexMarketLogo() {
  return (
    <svg viewBox="0 0 62.1 32" className="h-6 w-auto" aria-hidden="true">
      <defs>
        <clipPath id="yandex-market-logo-clip">
          <circle cx="47.1" cy="16" r="15" />
        </clipPath>
      </defs>
      <circle cx="47.1" cy="16" r="15" fill="#fed42b" />
      <circle cx="15" cy="16" r="15" fill="#fc3f1d" />
      <path fill="#fff" d="M17.2 9.4h-1.5c-2.6 0-3.9 1.3-3.9 3.3 0 2.2.9 3.3 2.8 4.6l1.5 1.1-4.3 6.7H8.3l4.1-6.1c-2.4-1.7-3.7-3.3-3.7-6.1 0-3.5 2.4-5.9 7-5.9h4.6v18h-3V9.4z" />
      <path clipPath="url(#yandex-market-logo-clip)" fill="#111" d="M39.7 9.2 26.5 26.5l3.5 4 9.8-13-1 7.1 5.5 1.9L51 15.8c-.3 2-.8 6.6 3.6 8 6.9 2.1 12.9-10.3 15.7-16.6l-4-2.1c-3.1 6.5-7.9 13.7-9.8 13.2-1.9-.5-.2-6.6.9-10.5v-.1l-6.1-2.1L44 17.5l1-6.5-5.3-1.8z" />
    </svg>
  );
}

const MARKETPLACE_LOGOS = {
  ozon: OzonLogo,
  wildberries: WildberriesLogo,
  "yandex-market": YandexMarketLogo,
};

const MARKETPLACE_LOGO_FRAME_CLASSNAMES = {
  ozon: "bg-[#005bff] text-white",
  wildberries: "bg-gradient-to-br from-[#cb11ab] to-[#7b1fa2] text-white",
  "yandex-market": "bg-[#fed42b]",
  "auto-ru": "bg-[#ff3b30] text-white",
  "avito-auto": "bg-[#00aaff] text-white",
  drom: "bg-[#d71920] text-white",
};

export function MarketplaceLogo({ marketplaceId, fallback, fallbackClassName = "" }) {
  const Logo = MARKETPLACE_LOGOS[marketplaceId];
  if (Logo) {
    return (
      <span className={`${LOGO_FRAME_CLASS} ${MARKETPLACE_LOGO_FRAME_CLASSNAMES[marketplaceId]}`} aria-hidden="true">
        <Logo />
      </span>
    );
  }

  return (
    <span className={`grid size-10 shrink-0 place-items-center rounded-full text-xs font-bold ${fallbackClassName}`} aria-hidden="true">
      {fallback}
    </span>
  );
}
